import { cloneDeep, isEqual } from "lodash";

export default {
  watch: {
    value: {
      deep: true,
      handler ( value ) {
        this.getValue( value );
      }
    },
    mutable: {
      deep: true,
      handler () {
        this.setValue();
      }
    }
  },
  data: () => ( {
    enablevModelLogging: false
  } ),
  created () {
    let fixed = this.value;

    if ( this.enablevModelLogging ) {
      console.groupCollapsed( "CREATED: ", this.$options.name );
      this.logValue( fixed );
    }

    // If our value is an object, ensure that our initial data has all keys.
    // This is useful as our passed value might be missing some things.
    if ( this.value === Object( this.value ) && !Array.isArray( this.value ) ) {
      fixed = Object.assign( {}, this.mutable, this.value );

      if ( this.enablevModelLogging ) {
        this.logValue( fixed );
      }
    } else if ( this.enablevModelLogging ) {
      console.log( "skipping" );
    }

    if ( this.enablevModelLogging ) {
      console.groupEnd();
    }

    // Assign our fixed value to our internal, mutable value.
    this.getValue( fixed );

    // Then emit our fix to any parent elements,
    // so that the external value is fixed too.
    this.setValue( fixed );
  },
  methods: {
    getValue ( value ) {
      if ( !isEqual( value, this.mutable ) ) {
        if ( this.enablevModelLogging ) {
          console.groupCollapsed( "VALUE CHANGED: ", this.$options.name );
          this.logValue( value );
          console.groupEnd();
        }

        this.mutable = cloneDeep( value );
      }
    },
    setValue () {
      if ( !isEqual( this.value, this.mutable ) ) {
        if ( this.enablevModelLogging ) {
          console.groupCollapsed( "MUTABLE CHANGED: ", this.$options.name );
          this.logValue( this.mutable );
          console.groupEnd();
        }

        this.$emit( "input", cloneDeep( this.mutable ) );
      }
    },
    logValue ( value ) {
      console.groupCollapsed( "Original value: " );
      console.log( JSON.stringify( value, null, 2 ) );
      console.groupEnd();
    }
  }
};
